import React from "react";
import classes from "./ProfileScreen.module.css";
import Navbar from "../../Navbar/Navbar";
import { getAuth, signOut } from "firebase/auth";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { logout, selectUser, selectGuest } from "../../features/UserSlice";
const ProfileScreen = () => {
  const dispatch = useDispatch();
  const user = useSelector(selectUser);
  const guest = useSelector(selectGuest);
  const email = user.email;
  const guestId = guest.guestid;
  const auth = getAuth();
  const navigate = useNavigate();
  // console.log(email);
  return (
    <div className={classes.profilescreen}>
      <Navbar />
      <div className={classes.profilescreen_body}>
        <h1>Edit Profile</h1>
        <div className={classes.profilescreen_info}>
          <img
            src="https://upload.wikimedia.org/wikipedia/commons/0/0b/Netflix-avatar.png"
            alt=""
          />

          <div className={classes.profilescreen_details}>
            <h2>
              {email}
              {guestId !== null ? "Logined as Guest" : ""}
            </h2>
            <div className={classes.profilescreen_plans}>
              <button
                onClick={() =>
                  signOut(auth)
                    .then(() => {
                      dispatch(logout);
                      // alert("Sign out successfully");
                      navigate("/login");
                    })
                    .catch((error) => {
                      // alert("An error happend.");
                    })
                }
                className={classes.profilescreen_signout}
              >
                Sign Out
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfileScreen;
